
export const expireTime = () => new Date(Date.now() + 15 * (24 * (60 * 60 * 1000))); // Token expiry time

export function getCurrency(amount) {
    const formattedAmount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(amount);

    return formattedAmount
}

export function downloadExcel(url) {
    if (!url) return;

    const link = document.createElement('a');
    link.href = url;
    link.download = url.split('/').pop();
    link.click();
};